import { dspLabel } from './format';

type Option = { value: string; label: string };

/** A selected platform keeps its chip even after it drops out of the fetched list, so it can be cleared. */
export const withSelectedPlatforms = (options: Option[], selected: string[]): Option[] => {
  const known = new Set(options.map(o => o.value));
  return [...options, ...selected.filter(v => !known.has(v)).map(v => ({ value: v, label: dspLabel(v) }))];
};
